import index from "./researchList.vue";
export default index;
